module.exports = __webpack_public_path__ + "static/media/confetti-deluxe.2316f197.png";